import { UserConsumer } from '../../core/providers/UserProvider';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import React, { Component } from 'react';
import BasicLayout from '../../core/BasicLayout';
import Errored from '../../core/Errored';
import Loading from '../../core/Loading';
import { makeCancelable } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import { NS_GS } from '../utils/constants';
import Applications from './Applications';
import MarketplaceManager from '../marketplace/MarketplaceManager';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';

const dayMilliseconds = 1000 * 3600 * 24;

class ApplicationsManager extends Component {

  constructor(props) {
    super(props);
    this.state = {
      applications: [],
      showExamples: GS.getActiveSubscriptionType() === "Trial",
      isLoading: true,
      isErrored: undefined
    };
    this.cancellable = null;
  }

  doSearch() {
    this.cancellable = makeCancelable(
      GS.search({
        search: [{
          predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
          value: NS_GS + "Application"
        }],
        graph: [this.props.activeSubscription],
        noCount: true,
        language: "en",
        page: 1,
        pageSize: 20
      })
    );
    return this.cancellable;
  }

  componentDidMount() {
    if (this.props.activeSubscription) {
      this.doSearch()
        .promise
        .then(data => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isLoading: false, applications: data.results });
        })
        .catch((e) => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        });
    }
    else {
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  render() {

    const { isLoading, applications, isErrored, showExamples } = this.state;
    const { tripleCount, maxTriplesAllowed, expirationDate } = this.props;

    const triplePercent = Math.floor((tripleCount) / maxTriplesAllowed * 100);
    const warningColour = triplePercent < 100 ? '#FF6F00' : '#DD2C00';

    if (isErrored) return <Errored data={isErrored} fatal={true} logOut={this.props.logOut} />;
    if (isLoading) return <BasicLayout><Loading /></BasicLayout>;

    const isExpiring = expirationDate && (expirationDate - Date.now() < dayMilliseconds * 8) ?
      Math.floor((expirationDate - Date.now()) / dayMilliseconds)
      :
      -1;

    return (
      <UserConsumer>
        {({ entitlements }) => {
          return <BasicLayout includeMargin={triplePercent < 80 && !isExpiring}>
            {(triplePercent >= 80 || isExpiring >= 0) &&
              <div style={{ height: isExpiring >= 0 ? '40px' : '54px', paddingLeft: 80, color: 'white', backgroundColor: warningColour, textAlign: 'center' }}>
                <span style={{ display: 'inline-block', verticalAlign: 'middle', paddingTop: '8px', paddingLeft: 12 }}>
                  <Typography variant="body2" data-test="warning">
                    <WarningIcon style={{ verticalAlign: 'middle', marginRight: 10 }} />
                    {isExpiring >= 0 ?
                      isExpiring > 0 ?
                        <span>Your subscription is due to expire {isExpiring} days from now.</span>
                        :
                        <span>Your subscription is due to expire within the next day.</span>
                      :
                      <React.Fragment>
                        {triplePercent <= 100 ?
                          <span>Your subscription is approaching the maximum amount of data allowed.</span>
                          :
                          triplePercent <= 120 ?
                            <span>You have slightly exceeded the maximum amount of data allowed.</span>
                            :
                            <span>You have greatly exceeded the maximum amount of data allowed.</span>
                        }
                        <span style={{ marginLeft: 10 }}>{triplePercent}% of maximum.</span>
                      </React.Fragment>
                    }
                  </Typography>
                  {isExpiring === -1 &&
                    <Typography variant="body2">Please consider upgrading your subscription.</Typography>
                  }
                </span>
              </div>
            }
            {entitlements.includes(APPENTITLEMENTS.CAN_IMPORT_PROJECT) && showExamples && <MarketplaceManager />}
            <Applications applications={applications} />
          </BasicLayout>;
        }}
      </UserConsumer>
    );
  }
}

ApplicationsManager.propTypes = {
  activeSubscription: PropTypes.string,
  logOut: PropTypes.func.isRequired,
  tripleCount: PropTypes.number,
  expirationDate: PropTypes.number,
  maxTriplesAllowed: PropTypes.number
};

export default ApplicationsManager;